import type { FaireProductEntity } from "../../entity_types/product";

export const p_cghd88nk3w: FaireProductEntity = {
  token: "p_cghd88nk3w",
  type: "product",
  name: "Sour Peach Fish - Swedish Candy 5.2oz (150g)",
  brandToken: "b_b19cqe097d",
  brandName: "BonBon - A Swedish Candy Co",
  imageUrl:
    "https://cdn.faire.com/fastly/4b4786b20dfb7d7a2c7069ce29c7d80dc6355dd86ad9e677c9cf8d3c3d0346c5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70383a70186019ca64b964fa73326ef5b6d5f232585f9794181f39f636bd4a68.png",
    "https://cdn.faire.com/fastly/85b30be89d4c48af1cb846f76dc89a671fa30719937842b78704fcf40579d119.png",
  ],
  priceDollars: 4,
  description:
    "The second member in our family of fish is the sour peach! With this flavor we set out to create a peach dominant gummy with a medium-chew, complemented by hints of fresh apricots.\n\nThe sour peach fish is actually an homage to our favorite American pie - the peach cobbler. The addition of apricot is a nod to our summers of youth, most of which were spent picking and eating apricots with Grandma in her garden.\n\nThe Sour Peach fish is a vegan, gluten-free, naturally colored and flavored sour candy made by a small factory in the south of Sweden.\n\nThis vegan and gluten-free candy is a fresh take on the classic Swedish Fish. Perfect inside a Easter gifting basket. The perfect Valentine's day gift.  ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:21.645Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
